import { render, staticRenderFns } from "./ResolveTypeLink.vue?vue&type=template&id=7e85c9f0&scoped=true"
import script from "./ResolveTypeLink.vue?vue&type=script&lang=js"
export * from "./ResolveTypeLink.vue?vue&type=script&lang=js"
import style0 from "./ResolveTypeLink.vue?vue&type=style&index=0&id=7e85c9f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e85c9f0",
  null
  
)

export default component.exports